import { isLinkActive } from '@/app/layouts/AsideMenu';
import { selectedClient } from '@/core/selectedClient';
import { filesNothingAtCompaniesHouse } from '@/core/useClientType';
import { useClientKind } from '@/features/tr-reportsettings/clientKind';
import { COMPLIANCE_FILING_ITEMS, COMPLIANCE_FILING_LABEL, complianceFilingItemsFor } from './menuItems';
import { SectionNav } from './SectionNav';

/** True on the four screens of the Compliance & Filing section (APT353). */
export const isComplianceFilingRoute = (pathname: string): boolean =>
  COMPLIANCE_FILING_ITEMS.some((i) => isLinkActive(pathname, i.to));

/**
 * APT353 (client): "Create a new parent section called Compliance & Filing ... display these four features in a top-row grid, following
 * the same UI/navigation pattern currently used for Adjustments & Reports". The same bar as APT348's, in the client's order: Statutory
 * Database | Validation Centre | iXBRL Tagging | Filing Status. A client that files nothing at Companies House has no iXBRL Tagging or
 * Filing Status, so its bar holds the first two.
 */
export function ComplianceFilingNav() {
  const clientType = useClientKind(selectedClient()?.id)?.clientType;
  return (
    <SectionNav
      label={COMPLIANCE_FILING_LABEL}
      items={complianceFilingItemsFor(filesNothingAtCompaniesHouse(clientType))}
      testId="compliance-filing-nav"
    />
  );
}
